import { render, staticRenderFns } from "./SelectBudget.vue?vue&type=template&id=453b0113"
import script from "./SelectBudget.vue?vue&type=script&lang=js"
export * from "./SelectBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports